import Icon from '@mui/icons-material/ArrowRight';
import { SvgIconPropsOverrides } from '../../../model/icon';

export default function ArrowRightIcon({ className = '', ...props }: SvgIconPropsOverrides) {
	return <Icon className={`${className}`} {...props} />;
}
